import { createContext, useContext, useMemo } from "react";
import { useQuery } from "react-query";
import { getCloudfrontBaseUrl } from "@media/api";
import { jsx as _jsx } from "react/jsx-runtime";
export var CloudfrontContext = /*#__PURE__*/createContext({});
export var CloudfrontContextProvider = function CloudfrontContextProvider(props) {
  var _useQuery = useQuery(["cloudfrontBaseUrl"], getCloudfrontBaseUrl),
    cloudfrontBaseUrl = _useQuery.data;
  return /*#__PURE__*/_jsx(CloudfrontContext.Provider, {
    value: useMemo(function () {
      return {
        cloudfrontBaseUrl: cloudfrontBaseUrl
      };
    }, [cloudfrontBaseUrl]),
    children: props.children
  });
};
export var useCloudfrontContext = function useCloudfrontContext() {
  return useContext(CloudfrontContext);
};